import React, { useState } from 'react';
import ConversationSnapshots from './sections/ConversationSnapshots';
import Conversations from './sections/Conversations/Conversations';
import { ConversationFiltersProvider } from './context/ConversationFiltersContext';
import { ConversationSnapshotFiltersProvider } from './context/ConversationSnapshotFiltersContext';
import { UserFeedbackFiltersProvider } from './context/UserFeedbackFiltersContext';
import UserFeedback from './sections/UserFeedback';
import ConversationDetails from './sections/ConversationDetails';
import { Modal } from '@peoplegrove/pg-components';
import classes from './styles.module.scss';

const SupportWidget = () => {
  const [selectedSessionAddress, setSelectedSessionAddress] = useState(null);

  const handleCloseModal = () => {
    setSelectedSessionAddress(null);
  };

  return (
    <div className={classes.root}>
      <ConversationSnapshotFiltersProvider>
        <ConversationSnapshots />
      </ConversationSnapshotFiltersProvider>
      <ConversationFiltersProvider>
        <Conversations setSelectedSessionAddress={setSelectedSessionAddress} />
      </ConversationFiltersProvider>
      <UserFeedbackFiltersProvider>
        <UserFeedback setSelectedSessionAddress={setSelectedSessionAddress} />
      </UserFeedbackFiltersProvider>

      <Modal
        id="conversation-details-modal"
        open={Boolean(selectedSessionAddress)}
        onClose={handleCloseModal}
        title="Conversation Details"
        behaviour="right-to-left"
        noPadding
        surfaceClassName={classes.conversationDetailsModal}
        cancelText="Close"
      >
        {selectedSessionAddress && (
          <ConversationDetails sessionAddress={selectedSessionAddress} />
        )}
      </Modal>
    </div>
  );
};

export default SupportWidget;
